// @ts-nocheck — Phase 1A: legacy code, types added incrementally
// Forecast model v6
// Per-month state:
//   eomTarget       — EDITABLE € total MRR target at end of month
//   churnAbs        — Editable € churn for the month
//   gtmTarget       — Editable € GTM target
//   gtmActual       — Editable € GTM actual
//   partnerMrr      — Editable € Partner target
//   partnerActual   — Editable € Partner actual
//   selfServeMrr    — Editable € Self-Serve target
//   selfServeActual — Editable € Self-Serve actual
//   seasonality     — Editable % (drives AE/SDR headcount math)
//   aes             — { [aeId]: { real } }    ← per-AE REAL only (target is global aeMonthlyTarget)
//   note            — string
//   locked          — bool
//
// Derivations:
//   targetAdd      = eomTarget - prevEomTarget + churnAbs    (driven by EOM target)
//   aeChannelGap   = targetAdd - gtmTarget - partnerMrr - selfServeMrr   (residual to be hit by AE pool)
//   aeHeadcount    = aeChannelGap / (aeMonthlyTarget * seasonality)
//   realAdd        = gtmActual + partnerActual + selfServeActual + Σ aes.real
//   realEom        = locked ? prev+realAdd-churn : (hasActuals ? same : eomTarget)

const MONTH_KEYS = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
const MONTH_LABELS_IT = {jan:"Gennaio",feb:"Febbraio",mar:"Marzo",apr:"Aprile",may:"Maggio",jun:"Giugno",jul:"Luglio",aug:"Agosto",sep:"Settembre",oct:"Ottobre",nov:"Novembre",dec:"Dicembre"};
const MONTH_LABELS_EN = {jan:"January",feb:"February",mar:"March",apr:"April",may:"May",jun:"June",jul:"July",aug:"August",sep:"September",oct:"October",nov:"November",dec:"December"};
const MONTH_SHORT     = {jan:"Jan",feb:"Feb",mar:"Mar",apr:"Apr",may:"May",jun:"Jun",jul:"Jul",aug:"Aug",sep:"Sep",oct:"Oct",nov:"Nov",dec:"Dec"};

const DEFAULT_STATE = /*EDITMODE-BEGIN*/{
  "lang": "it",
  // Schema version — bumped each time the state shape gains a new field that needs
  // a migration. Hydration paths run migrations only when state.schemaVersion <
  // CURRENT_SCHEMA_VERSION, then write the new version. Saves ~milliseconds per
  // load + makes the migration sequence explicit.
  //   v1: initial
  //   v2: partnerUpsell → setupUpsell rename (2026-04)
  //   v3: arpuChannels added (2026-05)
  "schemaVersion": 3,
  "avgBasket": 150,
  // Which channels feed the ARPU + LTV calculation. Default: GTM (Sales Pipeline 2.0,
  // includes both Marco's deals and AE-owned Italy deals via crossCheck) + Self-serve.
  // Partner is excluded (partner-revenue-share deals aren't end-customers). Upsells fold
  // into the numerator but NOT into the customer count — same customer, just bigger value.
  "arpuChannels": ["gtm", "selfServe", "upsells"],
  "aeMonthlyTarget": 10000,
  "aeDemosPerDay": 10,
  "aeCloseRate": 45,
  "sdrCallsPerDay": 60,
  "sdrToDemoRate": 15,
  "aeCount": 2,
  "aes": [
    {"id": "ae1", "name": "AE 1", "person": ""},
    {"id": "ae2", "name": "AE 2", "person": ""}
  ],
  "months": {
    "jan": {"eomTarget": 0,      "churnAbs": 0,    "gtmTarget": 0,     "gtmActual": 0,     "partnerMrr": 0,    "partnerActual": 0,    "selfServeMrr": 0,    "selfServeActual": 0,    "setupUpsell": 0, "upsellPipeline": 0, "seasonality": 100, "locked": true, "note": "Pre-launch"},
    "feb": {"eomTarget": 99,     "churnAbs": 0,    "gtmTarget": 99,    "gtmActual": 99,    "partnerMrr": 0,    "partnerActual": 0,    "selfServeMrr": 0,    "selfServeActual": 0,    "setupUpsell": 0, "upsellPipeline": 0, "seasonality": 60,  "locked": true, "note": "Start: 16 Feb"},
    "mar": {"eomTarget": 2153,   "churnAbs": 299,  "gtmTarget": 2089,  "gtmActual": 2089,  "partnerMrr": 49,   "partnerActual": 49,   "selfServeMrr": 0,    "selfServeActual": 0,    "setupUpsell": 0, "upsellPipeline": 215, "seasonality": 100, "locked": true},
    "apr": {"eomTarget": 7775,   "churnAbs": 59,   "gtmTarget": 4550,  "gtmActual": 4550,  "partnerMrr": 943,  "partnerActual": 943,  "selfServeMrr": 0,    "selfServeActual": 0,    "setupUpsell": 0, "upsellPipeline": 0, "seasonality": 100, "locked": true, "note": "First 2 weeks marketing was broken; H2 closed-won = 42.5%"},
    "may": {"eomTarget": 37468,  "churnAbs": 311,  "gtmTarget": 24003, "gtmActual": 24003, "partnerMrr": 6001, "partnerActual": 6001, "selfServeMrr": 0,    "selfServeActual": 0,    "setupUpsell": 0, "upsellPipeline": 0, "seasonality": 100, "locked": true},
    "jun": {"eomTarget": 65000,  "churnAbs": 1500, "gtmTarget": 11000, "gtmActual": null,  "partnerMrr": 3000, "partnerActual": null, "selfServeMrr": 1250, "selfServeActual": null, "setupUpsell": 0, "upsellPipeline": 0, "seasonality": 100},
    "jul": {"eomTarget": 100000, "churnAbs": 2500, "gtmTarget": 13000, "gtmActual": null,  "partnerMrr": 4500, "partnerActual": null, "selfServeMrr": 2200, "selfServeActual": null, "setupUpsell": 1500, "upsellPipeline": 1000, "seasonality": 100},
    "aug": {"eomTarget": 120000, "churnAbs": 4500, "gtmTarget": 6000,  "gtmActual": null,  "partnerMrr": 3500, "partnerActual": null, "selfServeMrr": 1500, "selfServeActual": null, "setupUpsell": 1500, "upsellPipeline": 1500, "seasonality": 55, "note": "DACH/IT on vacation"},
    "sep": {"eomTarget": 165000, "churnAbs": 4500, "gtmTarget": 13000, "gtmActual": null,  "partnerMrr": 7000, "partnerActual": null, "selfServeMrr": 4000, "selfServeActual": null, "setupUpsell": 2500, "upsellPipeline": 2500, "seasonality": 100},
    "oct": {"eomTarget": 210000, "churnAbs": 5800, "gtmTarget": 11000, "gtmActual": null,  "partnerMrr": 8500, "partnerActual": null, "selfServeMrr": 5000, "selfServeActual": null, "setupUpsell": 3000, "upsellPipeline": 3000, "seasonality": 100},
    "nov": {"eomTarget": 250000, "churnAbs": 7400, "gtmTarget": 9000,  "partnerMrr": 8500, "partnerActual": null, "selfServeMrr": 5500, "selfServeActual": null, "setupUpsell": 3500, "upsellPipeline": 3500, "seasonality": 100, "gtmActual": null},
    "dec": {"eomTarget": 285000, "churnAbs": 11000,"gtmTarget": 8000,  "gtmActual": null,  "partnerMrr": 8500, "partnerActual": null, "selfServeMrr": 6000, "selfServeActual": null, "setupUpsell": 4000, "upsellPipeline": 4000, "seasonality": 80, "note": "Last 2 weeks holiday slowdown"}
  },
  "scenarios": {
    "active": "base",
    "optimistic": {
      "eomTarget": 342000,
      "pros": "Onboarding 3+ AE entro Q3. Partnership strategiche attivate. Upsell expansion 30%.",
      "cons": "Burn rate alto. Pressione su delivery. Difficile da sostenere senza nuovi round.",
      "risks": "Hiring lento. Saturazione mercato. Concorrenza prezzo."
    },
    "pessimistic": {
      "eomTarget": 199500,
      "pros": "Budget conservato. Team focused su retention. Margine per pivot.",
      "cons": "Crescita sotto media SaaS Italia. Investitori scontenti. Difficile prossimo round.",
      "risks": "Mercato non risponde. AE non hire. Churn aumenta sopra 5%."
    }
  },
  "tableShowMoM": false,
  "chartScenarios": ["base"]
}/*EDITMODE-END*/;

// Compact money formatter: 320 → "€320", 12000 → "€12k", 1_250_000 → "€1,25M"
function fmtMoney(n, opts = {}) {
  if (n == null || isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const a = Math.abs(n);
  const fmt = (val, decimals = 0) => {
    const s = val.toFixed(decimals);
    return s.replace(".", ",");
  };
  let body;
  if (a >= 1_000_000) {
    const v = a / 1_000_000;
    body = fmt(v, v >= 100 ? 0 : v >= 10 ? 1 : 2) + "M";
  } else if (a >= 1000) {
    // Always show 1 decimal for k values (e.g. "23,5k" or "23,0k").
    body = fmt(a / 1000, 1) + "k";
  } else {
    body = fmt(a, 0);
  }
  // Strip trailing zeros only for M values (e.g. "2,00M" → "2M").
  // K values keep their decimal even when zero (e.g. "23,0k" stays "23,0k") per Marco's preference.
  body = body.replace(/,0+(?=M$)/, "");
  return (opts.noPrefix ? "" : "€") + sign + body;
}

// Money formatter — compact k/M form across the entire platform.
// Used to be a long-form "€50.400" — now "€50k" / "€1,2M" everywhere.
const eur = (n) => fmtMoney(n);

function getTodayInfo(lang) {
  // Snap to the year of our model (2026); for any other year, clamp to plan start/end.
  const now = new Date();
  const monthIdx = now.getMonth(); // 0=Jan
  // Map calendar month → MONTH_KEY (Feb=feb is index 1)
  const calendarToKey = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
  let monthKey = calendarToKey[monthIdx];
  if (!MONTH_KEYS.includes(monthKey)) monthKey = "feb"; // before Feb → Feb start
  // Month fraction (how far through the month we are)
  const dayOfMonth = now.getDate();
  const lastDay = new Date(now.getFullYear(), monthIdx + 1, 0).getDate();
  const monthFraction = Math.min(1, dayOfMonth / lastDay);
  const formatter = new Intl.DateTimeFormat(lang === "it" ? "it-IT" : "en-GB", {
    day: "numeric", month: "short", year: "numeric"
  });
  return {
    monthKey,
    monthFraction,
    dateStr: formatter.format(now),
  };
}

function computeMonth(key, state, prevRealEom, prevEomTarget, prevTargetAdd, scenarioScale = 1, dynamicArpu = null) {
  const m = state.months[key];
  const seasonality = (m.seasonality ?? 100) / 100;
  // Scenario scale only applies to NON-LOCKED months. Past (locked) is unchanged.
  const sc = m.locked ? 1 : (scenarioScale || 1);
  // Dynamic basket: for FUTURE (non-locked) months, replace state.avgBasket with the live ARPU
  // computed from HubSpot deals (closed-won customers). Past months keep their fixed avgBasket.
  // This makes SDR/AE math reflect actual customer ticket size, not the planned default.
  const effectiveBasket = (m.locked || !dynamicArpu || dynamicArpu <= 0) ? (state.avgBasket || 0) : dynamicArpu;
  const churnAbs = (typeof m.churnAbs === "number") ? m.churnAbs * (m.locked ? 1 : sc) : 0;

  // Editable EOM target. If missing, fall back to prev + 0 add.
  const eomTargetRaw = (typeof m.eomTarget === "number") ? m.eomTarget * sc : (prevEomTarget - churnAbs);
  const eomTarget = eomTargetRaw;

  // Channel TARGETS (€) — fixed inputs (scaled by scenario)
  const gtmTarget = (typeof m.gtmTarget === "number") ? m.gtmTarget * sc : 0;
  const partnerMrr = (typeof m.partnerMrr === "number") ? m.partnerMrr * sc : 0;
  const selfServeMrr = (typeof m.selfServeMrr === "number") ? m.selfServeMrr * sc : 0;
  // "Others" splits cleanly into FORECAST vs REAL:
  //   - setupUpsell / upsellPipeline   → FORECAST (planned, editable, baked in initial state)
  //   - setupUpsellActual / upsellPipelineActual / otherActual / otherUpsellActual → REAL (read-only, from HubSpot)
  // The hydrate effect in ForecastMarket writes HubSpot returns to the *Actual fields ONLY, so the
  // forecast values are never overwritten — that way future months keep their plan even if
  // HubSpot returns 0, and past months show both side-by-side (top = forecast, bottom = real).
  //
  // 2026-05 — Marco's directive: Upsell-by-team rolls INTO the GTM column;
  // only Upsell-by-non-team stays in the Others column (alongside Setup and
  // Other AEs). The Worker's upsellPipeline query is now crossCheck-aware:
  //   - upsellPipelineActual = team-owned upsells   (lives with GTM)
  //   - otherUpsellActual    = non-team upsells     (lives in Others)
  const setupUpsell = (typeof m.setupUpsell === "number") ? m.setupUpsell : 0;
  const upsellPipeline = (typeof m.upsellPipeline === "number") ? m.upsellPipeline : 0;
  const setupUpsellActual = (typeof m.setupUpsellActual === "number") ? m.setupUpsellActual : 0;
  const upsellPipelineActual = (typeof m.upsellPipelineActual === "number") ? m.upsellPipelineActual : 0;
  const otherActual = (typeof m.otherActual === "number") ? m.otherActual : 0;
  const otherUpsellActual = (typeof m.otherUpsellActual === "number") ? m.otherUpsellActual : 0;
  // Forecast total: drives aeChannelGap (residual to hit target) + othersPct (channel share).
  const othersTotal = setupUpsell + upsellPipeline;
  // Real total: bottom row of the Others cell. Now reflects only NON-GTM
  // upsell + Setup + Other AEs — team upsells live in the GTM column instead.
  const othersReal = setupUpsellActual + otherActual + otherUpsellActual;

  // Per-AE: REAL is per-month per-AE. TARGET defaults to global aeMonthlyTarget*seasonality
  // but can be overridden per-AE-per-month via month.aes[id].target
  const aes = (state.aes || []).map(ae => {
    const monthAE = (m.aes && m.aes[ae.id]) || {};
    const overrideTarget = (typeof monthAE.target === "number") ? monthAE.target : null;
    return {
      id: ae.id, name: ae.name,
      target: overrideTarget != null ? overrideTarget : (state.aeMonthlyTarget * seasonality),
      targetIsOverride: overrideTarget != null,
      real: (typeof monthAE.real === "number") ? monthAE.real : null,
    };
  });
  const aeTotalReal = aes.reduce((s, a) => s + (a.real || 0), 0);

  // Channel ACTUALS (€)
  const gtmActual = (typeof m.gtmActual === "number") ? m.gtmActual : null;
  const partnerActual = (typeof m.partnerActual === "number") ? m.partnerActual : null;
  const selfServeActual = (typeof m.selfServeActual === "number") ? m.selfServeActual : null;
  // 2026-05 — Marco's directive: the displayed GTM column rolls team-owned
  // upsells in alongside gtmActual. gtmActual itself stays as-is (raw GTM
  // pipeline only) for backward compat with anything that wants the pure
  // channel value; UI surfaces and the Real-Add roll-up use gtmTotal.
  // Null only when BOTH are absent — so the cell shows "—" for truly empty
  // months instead of forcing a 0 when one of the two is null.
  const gtmTotal = (gtmActual == null && upsellPipelineActual === 0)
    ? null
    : (gtmActual ?? 0) + upsellPipelineActual;

  // ROLLUPS: Target Add MRR is driven by editable EOM target
  const targetAdd = eomTarget - prevEomTarget + churnAbs;

  // AE channel = residual after subtracting fixed channels (incl. Others)
  const aeChannelGap = Math.max(0, targetAdd - gtmTarget - partnerMrr - selfServeMrr - othersTotal);
  const aePerHead = state.aeMonthlyTarget * seasonality;
  const aeHeadcountNeeded = aePerHead > 0 ? aeChannelGap / aePerHead : 0;
  // Hired-AE capacity = how many AEs are already on payroll × per-head target.
  // The "extra" gap is what remains after they cover their share.
  const hiredAeCount = (state.aes || []).length;
  const hiredAeCapacity = hiredAeCount * aePerHead;
  const aeRemainingGap = Math.max(0, aeChannelGap - hiredAeCapacity);
  // Round to nearest integer: 2.1 → 2, 2.5 → 3 (Marco's preference — slightly under-hire if <0.5 over).
  const extraHiresNeeded = aePerHead > 0 ? Math.round(aeRemainingGap / aePerHead) : 0;

  // Real Add: sum of any actuals provided.
  //
  // Per Marco's feedback (2026-05): Setup actual (setupUpsellActual) is
  // explicitly EXCLUDED from the realAdd total — Setup is a one-off fee,
  // not a recurring-channel add, so rolling it into "real target add"
  // misrepresented MRR additions. Setup is still tracked individually
  // (it remains in the month state as setupUpsellActual and is rendered
  // as its own chip in the Others cell's real row), but it doesn't roll
  // up into realAdd nor — by extension — into realEom. Marco will decide
  // later where Setup should plug in (one-time revenue ledger, etc.).
  //
  // 2026-05 also: Marco re-bucketed upsells. Team-owned upsells
  // (upsellPipelineActual) now live with GTM via gtmTotal; non-team
  // upsells (otherUpsellActual) are an Others contributor. The numeric
  // sum below is unchanged — we just sum from the new buckets so the
  // GTM column reflects what the user sees as "the team's revenue."
  //
  // othersReal still includes setupUpsellActual so existing consumers
  // (Others cell display, debug surfaces) don't change behavior.
  const othersRealForAdd = otherActual + otherUpsellActual;  // Setup excluded
  const realAdd = (gtmTotal ?? 0) + (partnerActual ?? 0) + (selfServeActual ?? 0) + aeTotalReal + othersRealForAdd;

  // Real EOM — computed from actual data only.
  // - Locked months: subtract churnAbs (which for past months ≈ HubSpot real after hydration).
  // - Non-locked months: subtract m.churnActual if HubSpot has returned a value, else 0.
  //   This avoids artificially lowering realEom by the planned-only churn (e.g. May plans
  //   €311 of forecast churn but no real Closed Lost has happened yet → realEom doesn't drop).
  const churnActual = (typeof m.churnActual === "number") ? m.churnActual : null;
  const churnForRealEom = m.locked ? churnAbs : (churnActual != null ? churnActual : 0);

  let realEom;
  const hasAnyActuals = (gtmActual != null) || (partnerActual != null) || (selfServeActual != null)
    || aeTotalReal > 0 || upsellPipelineActual > 0 || otherActual > 0 || otherUpsellActual > 0;
  if (m.locked) {
    realEom = Math.max(0, prevRealEom + realAdd - churnForRealEom);
  } else if (hasAnyActuals) {
    realEom = Math.max(0, (prevRealEom ?? 0) + realAdd - churnForRealEom);
  } else {
    realEom = null; // no actuals yet — do NOT show a fake number
  }

  // Churn % denominator differs for past vs future:
  //   - Past months (locked, real data from HubSpot): vs prev EOM (standard SaaS metric)
  //   - Future months (projection): vs prev month's Add MRR (Marco's preference for forecasting)
  // First month (no prior data): fall back to current eomTarget.
  const isFutureProjection = !m.locked;
  let churnBase;
  if (isFutureProjection && prevTargetAdd > 0) {
    churnBase = prevTargetAdd;
  } else if (prevEomTarget > 0) {
    churnBase = prevEomTarget;
  } else if (eomTarget > 0) {
    churnBase = eomTarget;
  } else {
    churnBase = realEom;
  }
  const churnPct = churnBase > 0 ? (churnAbs / churnBase) * 100 : 0;

  // % shares (derived) — based on targetAdd as denominator
  const pctOf = (n) => targetAdd > 0 ? (n / targetAdd) * 100 : 0;
  const gtmPct = pctOf(gtmTarget);
  const partnerPct = pctOf(partnerMrr);
  const selfServePct = pctOf(selfServeMrr);
  const othersPct = pctOf(othersTotal);
  const aePct = pctOf(aeChannelGap);

  // SDR math: drive from AE channel gap
  const aeDemosNeeded = effectiveBasket * (state.aeCloseRate / 100) > 0
    ? aeChannelGap / (effectiveBasket * (state.aeCloseRate / 100))
    : 0;
  const callsNeeded = state.sdrToDemoRate > 0 ? aeDemosNeeded / (state.sdrToDemoRate / 100) : 0;
  const sdrCapacity = state.sdrCallsPerDay * 21 * seasonality;
  const sdrNeeded = sdrCapacity > 0 ? callsNeeded / sdrCapacity : 0;

  return {
    key, locked: !!m.locked, seasonality: m.seasonality ?? 100,
    eomTarget, realEom,
    targetAdd, realAdd, hasAnyActuals,
    churnAbs, churnPct,
    gtmTarget, gtmActual, gtmTotal, gtmPct,
    partnerMrr, partnerActual, partnerPct,
    selfServeMrr, selfServeActual, selfServePct,
    setupUpsell, upsellPipeline, setupUpsellActual, upsellPipelineActual,
    otherUpsellActual,
    othersTotal, othersReal, othersPct,
    aes, aeTotalReal,
    aeChannelGap, aeHeadcountNeeded, aePct,
    hiredAeCount, hiredAeCapacity, aeRemainingGap, extraHiresNeeded,
    aeDemosNeeded, callsNeeded, sdrNeeded,
    effectiveBasket,  // exposed so UI can show "ARPU live" indicator on future months
    note: m.note || "",
  };
}

function computeForecast(state, scenarioScale = 1, dynamicArpu = null) {
  const rows = [];
  let prevRealEom = 0;
  let prevEomTarget = 0;
  let prevTargetAdd = 0;
  for (const k of MONTH_KEYS) {
    const r = computeMonth(k, state, prevRealEom, prevEomTarget, prevTargetAdd, scenarioScale, dynamicArpu);
    rows.push(r);
    if (r.realEom != null) prevRealEom = r.realEom;
    prevEomTarget = r.eomTarget;
    prevTargetAdd = r.targetAdd;
  }
  return rows;
}

const STRINGS = {
  it: {
    title: "Forecast MRR — verso 250k€ a Dicembre 2026",
    subtitle: "Calcolatore live · tutti i campi sono editabili",
    kpiTarget: "Obiettivo Dic 2026", kpiCurrent: "MRR attuale", kpiGap: "Gap da colmare", kpiAvgGrowth: "Crescita media richiesta",
    sectionAssumptions: "Assunzioni globali", sectionTimeline: "Timeline mensile", sectionTeam: "Team richiesto",
    colMonth: "Mese", colSeas: "Stagionalità",
    colEomTarget: "Tot MRR EOM", colEomReal: "Real EOM",
    colTargetAdd: "Target Add MRR", colRealAdd: "Real Add MRR",
    colChurnEur: "Churn €", colChurnPct: "Churn %",
    colMix: "Mix canali",
    colGTM: "GTM (io)", colAE: "AE necessari", colPartner: "Partner", colSelf: "Self-Serve", colOthers: "Others",
    colSDR: "SDR",
    othersTooltip: "Setup Upsell + Upsell Pipeline (espandibile)",
    aeCountLabel: "AE attivi",
    target: "Target", real: "Real", actual: "Reale",
    aesNeeded: "AE necessari",
    locked: "Storico", projection: "Proiezione",
    notes: "Note",
    callsPerSdr: "chiamate / SDR / mese",
  },
  en: {
    title: "MRR Forecast — to 250k€ by December 2026",
    subtitle: "Live calculator · every field is editable",
    kpiTarget: "Dec 2026 Target", kpiCurrent: "Current MRR", kpiGap: "Gap to close", kpiAvgGrowth: "Avg growth required",
    sectionAssumptions: "Global assumptions", sectionTimeline: "Monthly timeline", sectionTeam: "Team required",
    colMonth: "Month", colSeas: "Seasonality",
    colEomTarget: "Tot MRR EOM", colEomReal: "Real EOM",
    colTargetAdd: "Target Add MRR", colRealAdd: "Real Add MRR",
    colChurnEur: "Churn €", colChurnPct: "Churn %",
    colMix: "Channel mix",
    colGTM: "GTM (me)", colAE: "AEs needed", colPartner: "Partner", colSelf: "Self-Serve", colOthers: "Others",
    colSDR: "SDR",
    othersTooltip: "Setup Upsell + Upsell Pipeline (expandable)",
    aeCountLabel: "Active AEs",
    target: "Target", real: "Real", actual: "Actual",
    aesNeeded: "AEs needed",
    locked: "Actual", projection: "Projection",
    notes: "Notes",
    callsPerSdr: "calls / SDR / month",
  }
};

// ─── Zod boundary schemas ─────────────────────────────────────────────────
// Validate untrusted input at every boundary: localStorage, KV, HubSpot.
//
// Design choices:
// - .passthrough() on every object schema so unknown fields are KEPT (forward
//   compat with new server fields) but shape mismatches still fail.
// - Numeric fields are .nullable().optional() because the dashboard's "no real
//   data yet" sentinel is `null`, and migrations may leave fields absent.
// - z.enum on `lang` because we map locale strings to formatters; an unknown
//   value would produce silent wrong formatting.
//
// On failure, callers fall back to defaults + surface a toast (see
// app.jsx::validateOrFallback). If Zod itself didn't load (CDN failure), the
// helper returns the unvalidated payload — better than blocking the dashboard.
//
// Mirror these schemas in tests/schemas.test.mjs when changing them; the test
// file uses `import { z } from "zod"` (npm devDep) and verifies identical
// behavior. When they drift, tests fail.
const z = (typeof window !== "undefined" && window.Zod && window.Zod.z) || null;
if (typeof window !== "undefined" && !z) {
  console.warn("[fonio] Zod did not load — boundary validation disabled. State integrity relies on input being well-formed.");
}

const SCHEMAS = z ? (() => {
  const AESchema = z.object({
    id: z.string(),
    name: z.string(),
    person: z.string().optional(),
    hubspotOwnerId: z.string().optional(),
  }).passthrough();

  const MonthAESchema = z.object({
    target: z.number().nullable().optional(),
    real: z.number().nullable().optional(),
  }).passthrough();

  const MonthSchema = z.object({
    eomTarget: z.number().nullable().optional(),
    churnAbs: z.number().nullable().optional(),
    churnActual: z.number().nullable().optional(),
    gtmTarget: z.number().nullable().optional(),
    gtmActual: z.number().nullable().optional(),
    partnerMrr: z.number().nullable().optional(),
    partnerActual: z.number().nullable().optional(),
    selfServeMrr: z.number().nullable().optional(),
    selfServeActual: z.number().nullable().optional(),
    setupUpsell: z.number().nullable().optional(),
    setupUpsellActual: z.number().nullable().optional(),
    upsellPipeline: z.number().nullable().optional(),
    upsellPipelineActual: z.number().nullable().optional(),
    otherActual: z.number().nullable().optional(),
    // 2026-05 — added when upsellPipeline became crossCheck-aware. Non-team-
    // owned upsell deals split out from upsellPipelineActual into this bucket
    // and surface in the Others column.
    otherUpsellActual: z.number().nullable().optional(),
    seasonality: z.number().optional(),
    locked: z.boolean().optional(),
    note: z.string().optional(),
    aes: z.record(MonthAESchema).optional(),
  }).passthrough();

  const ScenariosSchema = z.object({
    active: z.string().optional(),
    optimistic: z.unknown().optional(),
    pessimistic: z.unknown().optional(),
  }).passthrough();

  const StateSchema = z.object({
    schemaVersion: z.number().optional(),
    lang: z.enum(["it", "en"]).optional(),
    avgBasket: z.number().optional(),
    arpuChannels: z.array(z.string()).optional(),
    aeMonthlyTarget: z.number().optional(),
    aeDemosPerDay: z.number().optional(),
    aeCloseRate: z.number().optional(),
    sdrCallsPerDay: z.number().optional(),
    sdrToDemoRate: z.number().optional(),
    aeCount: z.number().optional(),
    aes: z.array(AESchema).optional(),
    months: z.record(MonthSchema).optional(),
    scenarios: ScenariosSchema.optional(),
    tableShowMoM: z.boolean().optional(),
    chartScenarios: z.array(z.string()).optional(),
  }).passthrough();

  // HubSpot deal: we read ~10 fields, but the worker forwards more; passthrough
  // keeps unused fields available without forcing schema updates whenever the
  // worker adds a property (e.g. notes_last_updated for the deals popover).
  const HubSpotDealSchema = z.object({
    id: z.union([z.string(), z.number()]),
    name: z.string().nullable().optional(),
    company: z.string().nullable().optional(),
    closeDate: z.string().nullable().optional(),
    amount: z.number().nullable().optional(),
    pipeline: z.string().nullable().optional(),
    stage: z.string().nullable().optional(),
    ownerId: z.string().nullable().optional(),
    country: z.string().nullable().optional(),
    monthKey: z.string().nullable().optional(),
    cell: z.string().nullable().optional(),
  }).passthrough();

  // /api/actuals response: months is a per-month bag of channel→€ totals.
  // Every numeric value should be a number; the channel keys themselves are
  // dynamic (gtmActual, partnerActual, ...) so we use catchall(z.number()).
  const HubSpotActualsResponseSchema = z.object({
    months: z.record(z.record(z.number())).optional(),
    deals: z.array(HubSpotDealSchema).optional(),
    owners: z.record(z.unknown()).optional(),
    portalId: z.string().nullable().optional(),
    fetchedAt: z.string().nullable().optional(),
    fromCache: z.boolean().optional(),
    missingCells: z.array(z.string()).optional(),
    fiscalYear: z.unknown().optional(),
  }).passthrough();

  return { AESchema, MonthAESchema, MonthSchema, ScenariosSchema, StateSchema, HubSpotDealSchema, HubSpotActualsResponseSchema };
})() : {};

Object.assign(window, {
  MONTH_KEYS, MONTH_LABELS_IT, MONTH_LABELS_EN, MONTH_SHORT,
  DEFAULT_STATE, computeForecast, eur, fmtMoney, STRINGS, getTodayInfo,
  SCHEMAS,
});
// Permanent original-MRR formatters. NEVER overwrite these — they are the source of truth
// for "format this MRR value as MRR". The ARR toggle wraps window.eur/window.fmtMoney but
// must always rewrap from these immutable references, never compose on top of a previous wrap.
window.__EUR_MRR_PURE = eur;
window.__FMT_MONEY_MRR_PURE = fmtMoney;
